import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';

import { Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle } from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { addGlobalReportType } from '../../actions/report';

class globalForm extends Component {

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {reportData: false, edit: false}
        this.handleChange = this.handleChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.setCheckedValue = this.setCheckedValue.bind(this);
    }

    componentWillMount()
    {
        if(this.props.match.params.reportId)
        {

            const reportId = this.props.match.params.reportId;
            const reportType = this.props.reportData.data.find(e => e.id === reportId);
            const index = this.props.reportData.data.findIndex(e => e.id === reportId);

            this.setState({
                reportData : {
                    name: reportType.name,
                    is_active: reportType.is_active
                },
                id: reportType.id,
                index: index,
                selectedMetaCategories: reportType.selectedMetaCategories,              
                edit: true
            })            
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.addGlobalReportType(this.props.clientPath.clientPath, this.state);
    }

    setInputState(e) {
      this.setState({
          reportData: {...this.state.postData, [e.target.name]: e.target.value }
      });
    }

    handleChange(selectedOption) {

        this.setState({ selectedMetaCategories: selectedOption });
    }

    handleAddressChange(selectedOption) {
        this.setState({ selectedAddresses: selectedOption });
    }
    mapMetaCategories(val, key) {
         return { value: val.id, label: val.name }
    }  

    setCheckedValue(e) {
        this.setState({
            reportData: {...this.state.reportData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }

    render() {
   
        return (
            <div className="animated fadeIn">
             <Card>
                <CardBody>
                    <CardTitle><i className="fa fa-user"></i>Globale rapportagerubriek {this.state.edit ? 'bewerken' : 'toevoegen'}</CardTitle>
                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                        <FormGroup>
                            <Label for="name">Naam</Label>
                            <Input type="text" defaultValue={this.state.reportData ? this.state.reportData.name : ''} onChange={(e) => this.setInputState(e)} name="name" id="name" placeholder="Naam" />
                        </FormGroup>
                        <FormGroup>
                            <Label  for="metadata_category_id">Metacategorie</Label>
                            {this.props.metaCategoryData.data ?
                               <Select
                                    name="metadata_category_id"
                                    simpleValue={true}
                                    value={this.state.selectedMetaCategories}
                                    onChange={this.handleChange}
                                    multi={true}
                                    options={ this.props.metaCategoryData.data.map((metaCategory, key) => this.mapMetaCategories(metaCategory, key))}
                                  />
                              : null}
                        </FormGroup>                    

                        <FormGroup check>
                            <Label check for="is_active">
                                <Input type="checkbox" defaultChecked={this.state.reportData && this.state.reportData.is_active === '1' ? 'checked' : ''} onChange={(e) => this.setCheckedValue(e)} name="is_active" id="is_active" />
                                Is actief?
                            </Label>
                        </FormGroup>             
                        <button type="submit" className="btn btn-sm btn-primary">
                            <i className="fa fa-dot-circle-o"></i> {this.state.edit ? 'Bijwerken' : 'Toevoegen'}
                        </button>
                    </Form>
                </CardBody>

            </Card>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientPath: state.clientPathReducer,      
        reportData : state.ReportReducer,
        metaCategoryData : state.FileMetaDataCategoryReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFrontEndUser: (url, postData, attached_addresses) => dispatch(addFrontEndUser(url, postData, attached_addresses)),
        userEdited : (status) => dispatch(userEdited(status)),
        addGlobalReportType : (url, postData) => dispatch(addGlobalReportType(url, postData))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(globalForm))



// WEBPACK FOOTER //
// ./src/views/Report/globalForm.js